import type { MapFormDataToDtoOptions } from './mappers.types';

export function hasPositiveHourlyRate(hourlyRate: string | number | undefined | null): boolean {
  if (hourlyRate == null || hourlyRate === '') {
    return false;
  }

  const euros = typeof hourlyRate === 'number' ? hourlyRate : parseFloat(hourlyRate);
  return Number.isFinite(euros) && euros > 0;
}

export function mapHourlyRateCentsToFormValue(
  hourlyRateCents: number | null | undefined
): string | undefined {
  if (hourlyRateCents == null || hourlyRateCents <= 0) {
    return undefined;
  }

  return (hourlyRateCents / 100).toString();
}

export function assertFreelanceFormFields(
  isFreelance: boolean | undefined,
  hourlyRate: string | number | undefined | null,
  mutableUntilHours: string | undefined | null,
  options?: MapFormDataToDtoOptions
): void {
  if (!isFreelance) {
    return;
  }

  if (mutableUntilHours == null) {
    throw new Error('hourlyRate and mutableUntilHours are required for freelance jobs');
  }

  if (options?.allowMissingFreelanceHourlyRate) {
    return;
  }

  if (!hasPositiveHourlyRate(hourlyRate)) {
    throw new Error('hourlyRate and mutableUntilHours are required for freelance jobs');
  }
}
